module.exports = "/assets/data/5c78af279d88d3fb5471d41a9510da7a-WA1.data.json";